<template>
  <div class="main-background d-flex align-center justify-center">
    <v-form v-model="isValid">
      <v-card :style="{ width: '100%', maxWidth: '400px',minWidth: '400px' }">
        <v-card-title class="text-h5">
          {{ isLogin ? "Connexion" : "Créer un compte" }}
        </v-card-title>

        <v-card-text>
          <v-text-field
            v-model="email"
            label="E-mail"
            type="email"
            :rules="[formRules.required, formRules.email]"
            outlined
          />

          <v-text-field
            v-model="password"
            label="Mot de passe"
            type="password"
            :rules="!isLogin ? [formRules.required] : [rules.required]"
            outlined
            @keyup.enter="isLogin ? handleLogin() : handleRegister()"
          />

          <v-text-field
            v-if="!isLogin"
            v-model="confirmPassword"
            label="Confirmer le mot de passe"
            type="password"
            :rules="!isLogin ? [formRules.passwordMatch, formRules.required] : [null]"
            outlined
            @keyup.enter="handleRegister()"
          />
          <v-checkbox v-model="consent" v-if="!isLogin">
            <template v-slot:label>
              <div>
                J'accepte les 
                <a href="/conditions" @click.stop>Conditions générales d'utilisation, Politique de cookie et politique de confidentialité</a>
              </div>
            </template>
          </v-checkbox>
          <p v-if="authStore.error" class="error-message">{{ authStore.error }}</p>
        </v-card-text>

        <v-card-actions class="justify-center">
          <v-btn
            color="secondary"
            variant="tonal"
            @click="isLogin ? handleLogin() : handleRegister()"
          >
            {{ isLogin ? "Connexion" : "Créer un compte" }}
          </v-btn>
        </v-card-actions>

        <v-card-actions class="justify-center">
          <v-btn text @click="toggleMode">
            {{ isLogin ? "Pas encore de compte ? Crée en un !" : "Déjà un compte ? Se connecter" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script setup>
import { ref, reactive,onMounted } from 'vue';
import { useAuthStore } from '@/store/AuthStore';
import { useRouter } from 'vue-router';
import * as rules from '@/utils/rules';

const authStore = useAuthStore();
const router = useRouter();

const email = ref('');
const password = ref('');
const confirmPassword = ref('');
const consent = ref(false);
const isLogin = ref(true);
const isValid = ref(false);

const formRules = reactive({
  required: rules.required,
  email: rules.email,
  passwordStrength: rules.passwordStrength,
  passwordMatch: (value) => value === password.value || "Les mots de passe ne correspondent pas",
});

const handleLogin = async () => {
  if (isValid.value) {
    const success = await authStore.login(email.value, password.value);
    if (success) {
      router.push('/inventory');
    }
  }
};

const handleRegister = async () => {
  if (isValid.value) {
    const success = await authStore.register(email.value, password.value, consent.value);
    if (success) {
      router.push('/inventory');
    }
  }
};

const toggleMode = () => {
  isLogin.value = !isLogin.value;
  email.value = '';
  password.value = '';
  confirmPassword.value = '';
  consent.value = false;
  authStore.error = null;
};

onMounted(() => {
  authStore.error = null;
});


</script>

<style scoped>
.error-message {
  color: firebrick;
  text-align: center;
}
</style>
